import { atom } from 'jotai';
export const onboardingAccountDataAtom = atom({
    cpf: '',
    accountData: null,
    deviceId: null,
    fullName: '',
    password: '',
    maskedRecipient: null,
});
